import { GET_ALBUM, GET_RECOMMENDATIONS, GET_SONG, LIKE_SONG, LIKE_ALBUM, GET_LATEST, GET_POPULAR } from './actions';

const initialState = {
  /**
   * Recommended songs displayed in the trending
   * view.
   */
  recommendations: undefined,

  songs: {
    /**
     * Top 10 popular songs
     */
    popular: undefined,

    /**
     * Latest uploads
     */
    latests: undefined,
  },

  /**
   * Podcasts information
   */
  podcasts: {
    latests: undefined,
    popular: undefined,
  },

  /**
   * The current loaded album
   */
  album: {
    // Error while loading the album
    error: false,
    author: {},
    songs: [],
  },

  /**
   * The current loaded song
   */
  song: {
    // Error while loading the song
    error: false,
    album: {},
    author: {},
    audio: {},
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALBUM.SUCCESS:
      return {
        ...state,
        error: false,
        album: action.payload.published,
      };
    case GET_ALBUM.FAIL:
      return {
        ...state,
        album: {
          ...state.album,
          error: true,
        },
      };
    case GET_SONG.SUCCESS:
      return {
        ...state,
        error: false,
        song: action.payload.song,
      };
    case GET_SONG.FAIL:
      return {
        ...state,
        song: {
          ...state.song,
          error: true,
        },
      };
    case GET_RECOMMENDATIONS.SUCCESS: {
      return {
        ...state,
        recommendations: action.payload.recommendations,
      };
    }
    case GET_LATEST.SUCCESS: {
      return {
        ...state,
        songs: {
          ...state.songs,
          latests: action.payload.songs,
        },
        podcasts: {
          ...state.podcasts,
          latests: action.payload.podcasts,
        },
      };
    }
    case GET_POPULAR.SUCCESS: {
      return {
        ...state,
        songs: {
          ...state.songs,
          popular: action.payload.songs,
        },
        podcasts: {
          ...state.podcasts,
          popular: action.payload.podcasts,
        },
      };
    }
    case LIKE_ALBUM.REQUEST:
    case LIKE_ALBUM.FAIL:
      return {
        ...state,
        album: {
          ...state.album,
          isFavorite: !state.album.isFavorite,
        }
      };
    case LIKE_ALBUM.SUCCESS:
      return {
        ...state,
        album: {
          ...state.album,
          isFavorite: action.payload.album.isFavorite,
        }
      };
    case LIKE_SONG.REQUEST:
    case LIKE_SONG.FAIL:
      return {
        ...state,
        song: {
          ...state.song,
          isFavorite: !state.song.isFavorite,
        }
      };
    case LIKE_SONG.SUCCESS:
      return {
        ...state,
        song: {
          ...state.song,
          isFavorite: action.payload.song.isFavorite,
        }
      };
    default:
      return state;
  }
}
